import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, {
  IActionData,
  ITableColumn,
} from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import EditIcon from '@/components/Icons/EditIcon';
import PlusIcon from '@/components/Icons/PlusIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import ConfirmModal from '@/components/Modal/ConfirmModal';
import useFilter from '@/hooks/useFilter';
import { IPageInfo } from '@/interfaces/common.model';
import { IOffice } from '@/interfaces/officelocation.model';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import { RootState } from '@/redux/store';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
interface ITableData {
  id: string;
  index: number;
  name: string;
  company: string;
  address: string;
  range: string;
  toggleStatus: boolean;
}
interface IPageState extends IPageInfo {
  [key: string]: string | number | boolean | object | ITableData[] | undefined;
  pageSize: number;
  count: number;
  tableLoader: boolean;
  CustomerData: ITableData[];
  type: string;
  searchQuery: string;
}
export interface IOfficeResponse {
  status: boolean;
  message: string;
  data: {
    pageInfo?: IPageInfo;
    site: IOffice[];
  };
}
const OfficeLocation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [modal, setModal] = useState<boolean>(false);
  const [selectedId] = useState<string>('');
  const [isloading, setIsLoading] = useState<boolean>(false);
  const toggle = () => setModal(!modal);
  const [pageStates, setPageStates] = useState<IPageState>({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CustomerData: [],
    type: 'office',
    searchQuery: '',
  });
  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'name', label: 'Office' },
    { value: 'company', label: 'Company' },
    { value: 'address', label: 'Location' },
    { value: 'range', label: 'Range' },
    { value: 'toggleStatus', label: 'Status' },
  ];

  const getOfficeList = async () => {
    try {
      const filterState = {
        pageNumber: pageStates?.currentPage,
        pageSize: filterDetails?.pageSize,
        type: pageStates?.type,
        search: pageStates.searchQuery,
        orderBy: filterDetails?.orderBy,
      };
      setPageStates((prev) => ({
        ...prev,
        tableLoader: true,
        CustomerData: [],
      }));
      const API = `${API_URL}${API_ENDPOINT?.getSite}?${getFilterUrl(filterState)}`;

      const response: IOfficeResponse = await callApi(API, {
        method: 'GET',
      });
      console.log(response)
      const newData: ITableData[] = response?.data?.site?.map(
        (item, index) => ({
          ...item,
          index: index + 1,
          office: item?.name || '',
          company: item?.Company?.name || '',
          toggleStatus: item?.status ?? false,
        }),
      );
      setPageStates((prevState) => ({
        ...prevState,
        CustomerData: newData,
        count: response?.data?.pageInfo?.total ?? 0,
        totalPages: response?.data?.pageInfo?.totalPages ?? 0,
      }));
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      setIsLoading(false);
    }
  };

  // const ActionHandler = (data: ITableData) => {
  //   setSelectedId(data?.id);
  //   toggle();
  // };

  const handleStatusToggle = async (data: ITableData, status: boolean) => {
    try {
      const formData = new FormData();
      formData.append('status', status ? '0' : '1');

      const API = `${API_URL}${API_ENDPOINT?.updateSite}?siteId=${data?.id}`;
      const response: IOfficeResponse = await callApi(API, {
        method: 'POST',
        data: formData,
        multipart: true,
      });
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        getOfficeList();
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      const API = `${API_URL}${API_ENDPOINT?.deleteSite}?siteId=${selectedId}`;
      setIsLoading(true);
      const response: IOfficeResponse = await callApi(API, {
        method: 'GET',
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        toggle();
        getOfficeList();
      } else {
        showToastNotification('danger', response?.message);
        toggle();
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const ActionData: IActionData<ITableData>[] = [
    {
      label: 'Edit',
      className: 'btn btn-link',
      icon: <EditIcon />,
      title: 'edit',
      clickHandler: (data: ITableData) => {
        navigate(RoutesLink?.addOffice, { state: { data: data } });
      },
    },
    // {
    //   label: 'Delete',
    //   className: 'btn btn-link',
    //   icon: <DeleteIcon />,
    //   title: 'delete',
    //   clickHandler: ActionHandler,
    // },
  ];
  const orderByHandler = (e: ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      setUpdateFilterStates({
        orderBy: e.target.value,
      }),
    );
  };
  const { pageChangeHandler, handleChangePageSize, handleSearchChange } =
    useFilter(pageStates, setPageStates);
  useEffect(() => {
    getOfficeList();
  }, [
    pageStates.currentPage,
    filterDetails.pageSize,
    pageStates.searchQuery,
    filterDetails?.orderBy,
  ]);
  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Offices'}
            buttonText={'Add Office'}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.addOffice}
          />
          <CardLayout cardStyle="mb-4" isGrid={tableView === 'grid'}>
            <FilterComponent
              isGrid={false}
              handleSearch={handleSearchChange}
              orderByList={orderByList}
              orderByHandler={orderByHandler}
            />
            <CommonTable
              tableHeading={tableHeading}
              ActionData={ActionData}
              tableData={pageStates?.CustomerData}
              currentPage={pageStates?.currentPage}
              count={pageStates?.count}
              pageSize={filterDetails?.pageSize}
              isLoading={pageStates?.tableLoader}
              pageChangeHandler={pageChangeHandler}
              totalPages={pageStates?.totalPages}
              handleStatusToggle={handleStatusToggle}
              handleChangePageSize={handleChangePageSize}
            />
          </CardLayout>
        </div>
      </Layout>
      <ConfirmModal
        isOpen={modal}
        toggle={toggle}
        isLoading={isloading}
        submitHandler={handleDelete}
      />
    </>
  );
};

export default OfficeLocation;
